/* anonima product page (template: product.anonima): colour and size selectors, price, photos per colour,
   mobile gallery arrows and marquee speed. */
(function () {
  if (window.anonimaProductLoaded) return;
  window.anonimaProductLoaded = true;

  function formatMoney(cents) {
    var format = window.anonimaMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals':
          return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        case 'amount_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default:
          return withCommas + '.' + parts[1];
      }
    });
  }

  function initProduct(section) {
    var dataEl = section.querySelector('[data-anp-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var fieldsets = Array.prototype.slice.call(section.querySelectorAll('[data-anp-option]'));

    var idInput = section.querySelector('[data-anp-variant-id]');
    var addButton = section.querySelector('[data-anp-add]');
    var notifyButton = section.querySelector('[data-anp-notify]');

    // The stand-in "Notify me" button passes its click to Klaviyo's back-in-stock button,
    // waiting for Klaviyo to add it if it isn't there yet
    if (notifyButton) {
      notifyButton.addEventListener('click', function () {
        var buy = notifyButton.closest('.anp-buy') || section;
        var klaviyoButton = buy.querySelector('button.needsclick');
        if (klaviyoButton) return klaviyoButton.click();
        var observer = new MutationObserver(function () {
          var found = buy.querySelector('button.needsclick');
          if (!found) return;
          observer.disconnect();
          found.click();
        });
        observer.observe(buy, { childList: true, subtree: true });
        setTimeout(function () {
          observer.disconnect();
        }, 5000);
      });
    }
    var priceWrap = section.querySelector('[data-anp-price]');
    var colourFieldset = section.querySelector('[data-anp-colour-option]');
    var colourIndex = colourFieldset ? Number(colourFieldset.dataset.anpOption) : -1;
    var galleryTrack = section.querySelector('[data-anp-gallery-track]');

    function selectedOptions() {
      return fieldsets.map(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (value, i) {
          return value === options[i];
        });
      });
    }

    // When the picked combination doesn't exist (e.g. a size not made in this colour),
    // keep the option just changed and pick the closest variant for the rest.
    function closestVariant(options, changedIndex) {
      var candidates = variants.filter(function (v) {
        return v.options[changedIndex] === options[changedIndex];
      });
      return (
        candidates.find(function (v) {
          return v.available;
        }) || candidates[0]
      );
    }

    function checkOptions(variant) {
      fieldsets.forEach(function (fieldset, i) {
        var input = Array.prototype.find.call(fieldset.querySelectorAll('input'), function (el) {
          return el.value === variant.options[i];
        });
        if (input) input.checked = true;
      });
    }

    // A value is available when some in-stock variant has it with the other options as selected.
    // A colour is available while any size of it is in stock, whatever size is selected.
    function updateAvailability(options) {
      fieldsets.forEach(function (fieldset, i) {
        var isColour = i === colourIndex;
        fieldset.querySelectorAll('input').forEach(function (input) {
          var available = variants.some(function (v) {
            return (
              v.available &&
              v.options.every(function (value, j) {
                if (j === i) return value === input.value;
                return isColour || value === options[j];
              })
            );
          });
          var label = section.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function updateGallery(colour) {
      if (!galleryTrack || colourIndex < 0) return;
      galleryTrack.querySelectorAll('[data-anp-colour]').forEach(function (item) {
        item.hidden = item.dataset.anpColour !== colour;
      });
      galleryTrack.scrollTo({ left: 0 });
    }

    function update(event) {
      var options = selectedOptions();
      var variant = findVariant(options);
      if (!variant) {
        var changedIndex = event ? fieldsets.indexOf(event.currentTarget) : 0;
        variant = closestVariant(options, changedIndex);
        if (!variant) return;
        checkOptions(variant);
        options = variant.options.slice();
      }

      updateAvailability(options);
      if (colourIndex >= 0) {
        updateGallery(variant.options[colourIndex]);
        var colourName = section.querySelector('[data-anp-colour-name]');
        if (colourName) colourName.textContent = variant.options[colourIndex];
      }

      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (addButton) {
        addButton.hidden = !variant.available;
        addButton.disabled = !variant.available;
      }
      if (notifyButton) notifyButton.hidden = variant.available;

      // Fabric details and size on model set per variant (see snippets/anonima-variant-rich-text.liquid).
      section.querySelectorAll('[data-anp-variant-content]').forEach(function (el) {
        el.hidden = el.dataset.anpVariantContent !== String(variant.id);
      });

      if (priceWrap) {
        var regular = priceWrap.querySelector('[data-anp-price-regular]');
        var compare = priceWrap.querySelector('[data-anp-price-compare]');
        var tag = priceWrap.querySelector('[data-anp-price-tag]');
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (regular) regular.textContent = formatMoney(variant.price);
        if (compare) {
          compare.hidden = !onSale;
          compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        }
        if (tag) {
          tag.hidden = !onSale;
          if (onSale) {
            var percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            tag.textContent = priceWrap.dataset.salePrefix + ' ' + percent + '% ' + priceWrap.dataset.saleSuffix;
          }
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    fieldsets.forEach(function (fieldset) {
      fieldset.addEventListener('change', update);
    });
  }

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-anp-gallery-track]');
    var prev = gallery.querySelector('[data-anp-gallery-prev]');
    var next = gallery.querySelector('[data-anp-gallery-next]');
    if (!track || !prev || !next) return;

    function step(direction) {
      var item = track.firstElementChild;
      if (!item) return;
      var width = item.getBoundingClientRect().width;
      var max = track.scrollWidth - track.clientWidth - 1;
      if (direction > 0 && track.scrollLeft >= max) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && track.scrollLeft <= 0) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: width * direction, behavior: 'smooth' });
      }
    }

    prev.addEventListener('click', function () {
      step(-1);
    });
    next.addEventListener('click', function () {
      step(1);
    });
  }

  function initMarquee(marquee) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    var rate = (window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate)) || 1;

    marquee.querySelectorAll('[data-anp-threshold]').forEach(function (item) {
      var amount = Math.ceil((Number(item.dataset.anpThreshold) * rate) / 5) * 5;
      item.textContent = item.dataset.anpText.replace('[amount]', amount + ' ' + currency);
    });

    var track = marquee.querySelector('.anonima-marquee__track');
    var group = marquee.querySelector('.anonima-marquee__group');
    if (!track || !group) return;

    // Repeat the items until one group is wider than the screen, then double it for a seamless loop.
    // The width is read from a ResizeObserver, after the browser's own layout, and every copy goes in
    // at once, so starting the marquee never makes the browser lay out the page early or repeatedly.
    function build(setWidth) {
      var original = group.innerHTML;
      var copies = setWidth > 0 ? Math.min(20, Math.max(1, Math.ceil(window.innerWidth / setWidth))) : 1;
      if (copies > 1) group.innerHTML = new Array(copies + 1).join(original);
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);

      var speed = Number(marquee.dataset.speed) || 30;
      track.style.setProperty('--anp-marquee-duration', (setWidth * copies) / speed + 's');
    }

    if (!('ResizeObserver' in window)) {
      build(group.scrollWidth);
      return;
    }
    var observer = new ResizeObserver(function (entries) {
      observer.disconnect();
      build(entries[0].contentRect.width);
    });
    observer.observe(group);
  }

  function init() {
    document.querySelectorAll('.anp-main').forEach(initProduct);
    document.querySelectorAll('[data-anp-gallery]').forEach(initGallery);
    document.querySelectorAll('.anonima-marquee').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();